export const HeaderTwo = ({children, classes, styles}) => {
    return (
        <h2 style={styles} className={classes + ` HeaderTwo text-[37px] md:text-[2.8rem] text-center font-semibold leading-[1.1] w-[85%] lg:w-[40vw]`}>{children}</h2>
    )
}